import React from 'react';
import classnames from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import VotableAnswers from './VotableAnswers';
import VotedAnswers from './VotedAnswers';
import Timestamp from '../../../Timestamp';
import s from './Poll.scss';
var MAX_QUESTION_LENGTH = 55;
var Poll = function (_a) {
    var poll = _a.deviation.poll, width = _a.width, height = _a.height, className = _a.className, ariaHidden = _a["aria-hidden"];
    if (!poll) {
        return null;
    }
    var questionTruncated = poll.question && poll.question.length > MAX_QUESTION_LENGTH
        ? "".concat(poll.question.slice(0, MAX_QUESTION_LENGTH), "...")
        : poll.question;
    return (React.createElement(Section, { style: { width: width, height: height }, className: classnames(className, s['root']), "aria-hidden": ariaHidden },
        React.createElement(Heading, { className: s['question'] }, questionTruncated),
        React.createElement("div", { className: s['info'] },
            React.createElement("span", { className: s['date'] },
                React.createElement(Timestamp, { timestamp: poll.ts })),
            "\u00A0 | \u00A0",
            React.createElement("span", { className: s['vote-count'] },
                poll.votes,
                " votes")),
        poll.hasVoted ? (React.createElement(VotedAnswers, { poll: poll })) : (React.createElement(VotableAnswers, { poll: poll }))));
};
export default Poll;
//# sourceMappingURL=Poll.js.map